import { Theme } from '@mui/material';

export const eventCardSliderStyles = (theme: Theme) => ({
	root: {
		width: '100%',

		'& .swiper-slide': {
			width: 'auto',
			marginRight: '40px',
		},
	},
	eventsSliderBox: {
		justifyContent: 'space-between',
		p: { xs: '0 20px', md: '0 40px', lg: '0 60px' },
	},
	sliderControls: {
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
	},
	sliderSwipeButton: {
		border: '1px solid black',
		borderRadius: '50%',
		aspectRatio: '1/1',
		width: { xs: '36px', md: '52px' },
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '20px',
		backgroundColor: 'white',
	},
	sliderSwipeIcon: {
		position: 'relative',
	},
	sliderSwipeButtonDisabled: {
		opacity: '0.5',
	},
	eventsSliderTitle: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '18px', md: '32px', lg: '40px' },
		fontWeight: '600',
		textTransform: 'uppercase',
	},
	swiper: {
		marginTop: '46px',
	},
	eventsSlider: {
		mt: '40px',
		columnGap: '32px',
	},
	noEventsText: {
		fontFamily: 'Integral CF',
		fontSize: '25px',
		fontWeight: '600',
		textTransform: 'uppercase',
		color: '#6D7275',
	},
	showMoreBox: {
		mt: { xs: '40px', md: '60px', lg: '72px' },
	},
});
